import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form, InputGroup } from 'react-bootstrap';

type CopyFieldProps = {
    label: string;
    onCopy: (value: string) => void;
    value: string;
};

/** A labelled, read-only value paired with a Copy button — the recurring "copy this credential" row on the Integrations page. */
export const CopyField = (props: CopyFieldProps) => {

    const { label, onCopy, value } = props;

    const { formatMessage } = useIntl();

    return (
        <Form.Group>
            <Form.Label className="fw-bold">
                {label}
            </Form.Label>
            <InputGroup>
                <Form.Control disabled aria-label={label} value={value} />
                <GMetrixButton aria-label={formatMessage({ id: 'copy_label.7c6daed7', defaultMessage: 'Copy {label}' }, { label })} iconClass="fa-regular fa-copy" onClick={() => value && onCopy(value)} variant="outline-primary">
                    <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                </GMetrixButton>
            </InputGroup>
        </Form.Group>
    );

};
